import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-203b9d3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "name-wrapper" }
const _hoisted_3 = { class: "info-tooltip" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "slide-metadata" }
const _hoisted_6 = { class: "stain" }
const _hoisted_7 = { class: "tissue_type" }
const _hoisted_8 = { class: "visuals-wrapper" }
const _hoisted_9 = {
  key: 0,
  class: "visuals"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "no_label" }
const _hoisted_12 = {
  key: 1,
  class: "visuals"
}
const _hoisted_13 = { class: "no_label" }
const _hoisted_14 = {
  key: 2,
  class: "visuals"
}
const _hoisted_15 = {
  key: 3,
  class: "visuals"
}
const _hoisted_16 = { class: "visuals-label" }
const _hoisted_17 = {
  key: 0,
  class: "technical-wrapper"
}
const _hoisted_18 = {
  key: 1,
  class: "labels-wrapper"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "k-icon k-i-arrow-chevron-right"
}
const _hoisted_21 = {
  key: 1,
  class: "resolution"
}
const _hoisted_22 = {
  key: 2,
  class: "labels-wrapper"
}
const _hoisted_23 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ib_icons = _resolveComponent("ib-icons")!
  const _component_slide_img = _resolveComponent("slide-img")!
  const _component_ILabel = _resolveComponent("ILabel")!
  const _component_DeleteSlideDialog = _resolveComponent("DeleteSlideDialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[
      {
        current: _ctx.slide.slideId === _ctx.activeSlideId,
        technical: _ctx.isTechnicalIssue(_ctx.slide),
      },
      _ctx.theme,
    ], "slide"]),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectSlide(_ctx.slide, 0)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ib_icons, {
          class: "extra-info-icon",
          icon: 'information',
          color: _ctx.theme === 'light' ? 'primary' : 'white',
          size: 16
        }, null, 8, ["color"]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slide.scores, (score) => {
            return (_openBlock(), _createElementBlock("div", {
              key: score.scoreId
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.t(`scores.${score.scoreType}`)) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.n(parseFloat(score.scoreValue), "decimal")), 1)
            ]))
          }), 128)),
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.t("slides.info.scanner_model")) + ":", 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.slide.scanner), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.t("slides.info.scan_magnification")) + ":", 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.slide.magnification), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.t("slides.info.scan_date")) + ":", 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.slide.date), 1)
          ])
        ]),
        _createElementVNode("span", {
          class: "logical-name",
          title: _ctx.slide.logicalName
        }, _toDisplayString(_ctx.slide.logicalName), 9, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.slide.stain), 1),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.tissue), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.hasNoThumbs(_ctx.slide.thumbs))
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("img", { src: _ctx.slideThumbnail }, null, 8, _hoisted_10),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.t("slides.no_label")), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isMacroNoLabel(_ctx.slide))
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_ctx.slide.thumbs.macro)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "slide-preview",
                  style: _normalizeStyle({backgroundImage: `url(${_ctx.BFF_BASE_PATH}/slide/${encodeURIComponent(_ctx.slide.slideId)}/macro)`})
                }, null, 4))
              : (_ctx.slide.thumbs.thumbnail)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "slide-preview",
                    style: _normalizeStyle({backgroundImage: `url(${_ctx.BFF_BASE_PATH}/slide/${encodeURIComponent(_ctx.slide.slideId)}/thumbnail)`})
                  }, null, 4))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_ib_icons, {
                class: "warning-icon",
                icon: 'exclamation_mark_grey_circle',
                size: 20
              }),
              _createElementVNode("div", null, _toDisplayString(_ctx.t("slides.no_label")), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.slide.thumbs.combo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_slide_img, {
              slide: _ctx.slide,
              path: _ctx.slide.thumbs.combo
            }, null, 8, ["slide", "path"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isMacroLabel(_ctx.slide))
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (_ctx.slide.thumbs.macro)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "slide-preview",
                  style: _normalizeStyle({backgroundImage: `url(${_ctx.BFF_BASE_PATH}/slide/${encodeURIComponent(_ctx.slide.slideId)}/macro)`})
                }, null, 4))
              : (_ctx.slide.thumbs.thumbnail)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "slide-preview",
                    style: _normalizeStyle({backgroundImage: `url(${_ctx.BFF_BASE_PATH}/slide/${encodeURIComponent(_ctx.slide.slideId)}/thumbnail)`})
                  }, null, 4))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_slide_img, {
                path: "label",
                slide: _ctx.slide
              }, null, 8, ["slide"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isFirstRead && _ctx.isTechnicalIssue(_ctx.slide))
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_ib_icons, {
            class: "warning-icon",
            icon: 'exclamation_mark_grey_circle',
            size: 20
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.t("slides.analysis_aborted", { reason: _ctx.t(`slides.technical.${_ctx.slide.screeningClass}`) })), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isSecondRead && _ctx.slide.alerts?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slide.alerts, (alert, index) => {
            return (_openBlock(), _createElementBlock("span", {
              class: _normalizeClass(["slide-alert", 
          alert.alertType === _ctx.AlertType.OUT_OF_FOCUS ||
          alert.alertType === _ctx.AlertType.TISSUE_IN_SLIDE
            ? 'technical'
            : 'clinical'
        ]),
              key: alert.alertId,
              onClick: _withModifiers(($event: any) => (_ctx.selectSlide(_ctx.slide, index)), ["stop"])
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.t(`config.alert.alert_type_dict.${alert.alertType}`)), 1),
              (alert.resolution !== _ctx.AlertResolution.NONE)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                : _createCommentVNode("", true),
              (alert.resolution !== _ctx.AlertResolution.NONE)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.t(`config.alert.resolutions_dict.${alert.resolution}`)), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_19))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isFirstRead && !_ctx.isTechnicalIssue(_ctx.slide))
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          (_ctx.slideLabels?.length)
            ? (_openBlock(), _createBlock(_component_ib_icons, {
                key: 0,
                class: "ai-icon",
                icon: 'ai',
                size: 14
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slideLabels, (label, index) => {
            return (_openBlock(), _createBlock(_component_ILabel, {
              key: index,
              "label-key": label.key,
              size: 14,
              title: _ctx.t(`config.insight.labels.${_ctx.activeCaseTissue}.${label.key}.title`),
              likelihood: label.likelihood
            }, null, 8, ["label-key", "title", "likelihood"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      (_ctx.showSlideDeletion)
        ? (_openBlock(), _createBlock(_component_ib_icons, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.deleteDialog = true), ["stop"])),
            class: "delete-icon",
            icon: 'trash_can_blue',
            color: 'primary',
            size: 20
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isCompleted(_ctx.slide))
      ? (_openBlock(), _createBlock(_component_ib_icons, {
          key: 3,
          class: "completed-icon",
          icon: 'v_green_circle',
          size: 24
        }))
      : _createCommentVNode("", true),
    (_ctx.deleteDialog)
      ? (_openBlock(), _createBlock(_component_DeleteSlideDialog, {
          key: 4,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteDialog = false)),
          slide: _ctx.slide
        }, null, 8, ["slide"]))
      : _createCommentVNode("", true)
  ], 2))
}